"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versionDocs = void 0;
var versionDocs = {
  name: 'version',
  category: 'Constants',
  syntax: ['version'],
  description: 'A string with the version number of math.js',
  examples: ['version'],
  seealso: []
};
exports.versionDocs = versionDocs;